module.exports = __webpack_public_path__ + "img/img_b@2x.cef13457.png";